export const EVENT_STYLES = {
  circle:  { color: '#0077b6', symbol: 'circle' },
  diamond: { color: '#e07b00', symbol: 'diamond' },
};
export const DEFAULT_EVENT_STYLE = { color: '#888888', symbol: 'circle' };

export const SIGNAL_DOMAIN = [0, 0.84];
export const LABEL_DOMAIN  = [0.84, 1.0];
export const TOOLBAR_H     = 46;
export const SECTION_ALPHA = '28';

export const LABEL_TYPES = {
  IA: { iconType: 'circle', label: 'IA', color: '#0077b6' },
  JALON: { iconType: 'diamond', label: 'Jalon', color: '#e07b00' },
};

export const COULEURS_PHASES = [
  '#e07b00',
  '#0077b6',
  '#26b36a',
  '#9b2226',
  '#6a0572',
  '#2f46d8',
  '#2d6a4f',
];
